import TipsSection from './TipsSection.jsx';

export default TipsSection;
